export function createGetConfig(config) {
    return function getConfig(key) {
        return config[key];
    };
}
